import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Customize from '@/pages/Customize'
import Mobile from '@/pages/Mobile'
import CustomizeMobile from '@/pages/CustomizeMobile'

Vue.use(Router);
// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location, onResolve, onReject) {
//   return originalPush.call(this, location).catch(err => err)
// }

// 缓存原型上的push函数
const originPush = Router.prototype.push
const originReplace = Router.prototype.replace
// 给原型对象上的push指定新函数函数
Router.prototype.push = function (location, onComplete, onAbort) {
  // 判断如果没有指定回调函数, 通过call调用源函数并使用catch来处理错误
  if (onComplete===undefined && onAbort===undefined) {
    return originPush.call(this, location, onComplete, onAbort).catch(() => {})
  } else { // 如果有指定任意回调函数, 通过call调用源push函数处理
    originPush.call(this, location, onComplete, onAbort)
  }
}
// replace同理处理
Router.prototype.replace = function (location, onComplete, onAbort) {
  if (onComplete===undefined && onAbort===undefined) {
    return originReplace.call(this, location, onComplete, onAbort).catch(() => {})
  } else {
    originReplace.call(this, location, onComplete, onAbort)
  }
}

const createRouter = () =>
  new Router({
    mode: 'history',
    routes: [
      {
        path: '/home',
        name: 'home',
        component: Home,
      },
      {
        path: '/customize',
        name: 'customize',
        component: Customize,
      },
      {
        path: '/mobile',
        name: 'mobile',
        component: Mobile,
      },
      {
        path: '/customizeMobile',
        name: 'customizeMobile',
        component: CustomizeMobile,
      }
    ]
  });


const whiteList = ['/CustomizeMobile',"/Mobile","/CustomizeMobile","/home"];

const router = createRouter();
router.beforeEach(async (to, from, next) => {
    // 未登录
    if (whiteList.indexOf(to.path) !== -1) {

      console.log("正常的路由"+to.path)
      next();
    } else {
      console.log("异常的路由"+to.path)
      next('/home');
    }
});

router.afterEach(() => {
});

router.onError(err => {
  console.log('router err', err);
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js